import usTranslations from './en-US/';  // english
import inTranslations from './in';  // indonessian


export default {
    ...usTranslations,
    ...inTranslations,
};
